// extracted by mini-css-extract-plugin
module.exports = {"badgeContainer":"Badge_badgeContainer__J2Xff","badgeBorder":"Badge_badgeBorder__fmRLl","badge":"Badge_badge__Kz2LE"};